(() => {
  const selector = '.product__title h1, .card__heading a, .viro-home__feature h2 a, .cart-item__name, .product-option dd, .product-form__input label, .viro-footer p';
  const formatRanges = (root) => {
    const targets = [...root.querySelectorAll(selector)];
    if (root.matches?.(selector)) targets.push(root);
    for (const target of targets) {
      const walker = document.createTreeWalker(target, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        const text = walker.currentNode;
        if (text.data.includes('\u2066') || !/\d{1,2}\s*[-–]\s*\d{1,2}/.test(text.data)) continue;
        text.data = text.data.replace(/\b(\d{1,2}\s*[-–]\s*\d{1,2})\b/g, '\u2066$1\u2069');
      }
    }
  };
  const start = () => {
    formatRanges(document);
    const observer = new MutationObserver((records) => {
      for (const record of records) {
        for (const node of record.addedNodes) if (node.nodeType === Node.ELEMENT_NODE) formatRanges(node);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

// Delegation keeps copying available after cart section updates.
document.addEventListener('click', async (event) => {
  const button=event.target.closest('[data-viro-copy-code]');
  if(!button)return;
  const status=button.closest('.viro-coupon').querySelector('.viro-coupon__status');
  try{
    await navigator.clipboard.writeText(button.dataset.viroCopyCode);
    status.textContent=button.dataset.copySuccess;
  }catch{
    status.textContent=button.dataset.copyFallback;
  }
});
